<template>
  <sq-form
    :class="formDada.canceled ? 'canceled-customer' : ''"
    v-if="!loading"
    ref="form"
    :model="formDada"
    label-width="120px"
    v-loading="pocessing"
    element-loading-text="pocessing..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <!-- <h1>ghelk</h1>-->

    <s-form-item label="Contact Name">
      <el-input v-model="formDada.leader"></el-input>
    </s-form-item>
    <s-form-item label="Referense Number">
      <el-input v-model="formDada.reference"></el-input>
    </s-form-item>
    <s-form-item label="General Notes">
      <el-input v-model="formDada.comment_general"></el-input>
    </s-form-item>
    <s-form-item label="Accommodation Notes">
      <el-input v-model="formDada.comment_accommodation"></el-input>
    </s-form-item>
    <s-form-item label="Activity Notes">
      <el-input v-model="formDada.comment_activity"></el-input>
    </s-form-item>
    <s-form-item label="Height">
      <el-input v-model="formDada.comment_height"></el-input>
    </s-form-item>
    <s-form-item label="Room Type" :sz="8">
      <el-select
        v-model="formDada.comment_room"
        placeholder="Types"
        @change="updatePax()"
      >
        <el-option label="Single" value="single"></el-option>
        <el-option label="Double" value="double"></el-option>
        <el-option label="Twin" value="twin"></el-option>
        <el-option label="Triple" value="triple"></el-option>
      </el-select>
    </s-form-item>
    <s-form-item label="Pax Adults" :sz="8">
      <s-input v-model="formDada.comment_adults"></s-input>
    </s-form-item>
    <s-form-item label="Pax Kids" :sz="8">
      <s-input v-model="formDada.comment_kids"></s-input>
    </s-form-item>

    <s-form-actions slot="actions">
      <el-checkbox v-model="formDada.delete_bookings" style="color: #ff0000"
        >!!!delete also bookings</el-checkbox
      >
      <sf-button
        :confirm="formDada.delete_bookings ? 'are you crazy?' : 'are you sure?'"
        type="danger"
        style="float: left"
        @click="deleteData()"
        >Delete</sf-button
      >
      <sf-button
        @click="cancelToggle()"
        :type="!formDada.canceled ? 'warning' : 'success'"
        size="mini"
        round
        >{{ !formDada.canceled ? "Cancel" : "Bring it back" }}</sf-button
      >
      <sf-button type="primary" @click="savecustomer()">Save</sf-button>
      <sf-button @click="$emit('done')" type="text">
        <i class="material-icons">clear</i>
      </sf-button>
    </s-form-actions>
  </sq-form>
</template>

<script>
import * as api from "~/api/resource";
import commons from "~/mixins/commons";
export default {
  mixins: [commons],
  async mounted() {
    var vm = this;
    await this.loadcustomer();

    this.loading = false;
  },
  data() {
    return {
      loading: true,
      errors: {},
      pocessing: false,
      formDada: {},
      selectedFlightId: null,
      searchFlightDateArv: null,
      searchFlightDateDep: null,
      depFlightDate: null,
    };
  },
  methods: {
    test(dt) {
      // this.$nextTick(() => {
      this.$set(this.formDada, "arvFlightDate", dt.time);
      _log_("chanf test ", dt, this.formDada.arvFlightDate);
      // });
    },
    updatePax() {
      _log_("chanf", this.formDada.comment_adults);
      if (this.formDada.comment_adults) return;
      // if(formDada.comment_adults&&formDada.comment_adults!="")return
      switch (this.formDada.comment_room) {
        case "single":
          this.formDada.comment_adults = 1;
          break;
        case "double":
          this.formDada.comment_adults = 2;
          break;
        case "twin":
          this.formDada.comment_adults = 2;
          break;
        case "triple":
          this.formDada.comment_adults = 3;
          break;
        default:
          break;
      }
    },
    async deleteData() {
      this.pocessing = true;

      try {
        this.formDada = await api.removeObject("customers", this.formDada);
      } catch (error) {
        _log_("error", error);
        this.$message.error("Oops, " + error.message);
        this.pocessing = false;
        return;
      }

      this.$emit("delete", this.formDada);
      this.$emit("done", null);
      this.pocessing = false;
    },
    getTheFlight(o) {
      _log_("ooo ", o);
    },
    editFlight() {
      this.routeGo({
        name: "tripeditor",
        params: {
          tripid: this.selectedFlightId ? this.selectedFlightId : "new",
        },
      });
    },
    cancelToggle() {
      if (!this.formDada.canceled) this.formDada.canceled = this.unxnow();
      else this.formDada.canceled = 0;
      this.savecustomer();
    },
    async savecustomer() {
      this.pocessing = true;
      this.formDada.planned_package_id = this.formDada.planned_package_id
        ? this.formDada.planned_package_id
        : this.$route.params.tripid;
      this.formDada.reference = this.formDada.reference
        ? this.formDada.reference
        : "_!ref_";
      // this.formDada.package_id = this.formDada.package_id
      //   ? this.formDada.package_id
      //   : ScheduleTrip.serviseId;
      _log_("data;;;;",   this.formDada);
      let sentData=JSON.parse(JSON.stringify( this.formDada))
      delete sentData.trips
      this.formDada = await api.updateProcessor(
        "customers/update",
          sentData
      );
      this.$emit("done", this.formDada);
      this.$emit("update", this.formDada);
      this.pocessing = false;
    },
    async loadcustomer(bkid) {
      this.loading = true;
      bkid = bkid ? bkid : this.$route.params.customerid;
      // _log_("data;;;;", arvData);
      if (bkid && bkid != "new") {
        this.formDada = await api.fetchObject("customers", {
          id: bkid,
        });
        // const arvData = await api.fetchList("booking", { customer_id: bkid });
      } else
        this.formDada = await api.fetchObject("customers", {
          planned_package_id: this.$route.params.tripid,
        });

      this.loading = false;
    },
  },

  watch: {
    "$route.params.customerid": async function (bkid, oldval) {
      _log_("get b oo ", bkid, oldval);
      if (bkid != oldval) {
        await this.loadcustomer(bkid);
        // this.loading = true;
        // var { data } = await api.fetchProcessor(
        //   "customers/vuecustomer",
        //   this.$route.query
        // );
        // this.customer = data.results;
        // this.loading = false;
      }
    },
  },
  computed: {
    colFlights() {
      return [
        {
          prop: "flight",
          label: "flight",
          editable: true,
          width: "180px",
        },
        {
          prop: "time",
          label: "time",
          editable: true,
          width: "180px",

          formatter(val) {
            if (val) return dateHelper.format(val * 1000, "DD/MM/YYYY , HH:mm");
            return "&nbsp;";
          },
        },
        {
          prop: "airport",
          label: "airport",
          editable: true,
          width: "180px",
        },
        {
          prop: "delete",
          width: "60px",
          label: "X",
          sortable: false,
          viewcomponent: {
            is: "el-button",
            icon: "el-icon-delete",
            type: "danger",
            circle: true,
          },
          formatter(val, colDefs, row) {
            return "-";
            // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';
          },
        },
      ];
    },
  },
};
</script>
<style>
.canceled-customer {
  background-color: tomato;
}
</style>
